import React from "react";
import MarketSectorListForm from './list/MarketSectorListForm';
import CreateMarketSectorForm from './create/CreateMarketSectorForm'

const MarketSectorView = ({ displayList }) => {
  return displayList ? (
    <MarketSectorListForm />
  ) : (
    <CreateMarketSectorForm />
  );
};

export default MarketSectorView;
